import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { getBidTitleDetails } from '@bingads-webui-campaign-react/wizard-shared-components';
import { BudgetTypes } from '../../../common/constants';

export const BudgetBidStrategyDetails = ({ budget, biddingScheme }) => {
  const i18n = useContext(I18nContext);
  const serverContext = useContext(ServerContext);

  const {
    Amount,
    Id,
    Type,
  } = budget || {};

  const budgetTitleDetails = useMemo(() => {
    if (Id) {
      return i18n.getString(_TL_('Budget applied from shared library'));
    }

    if (Amount == null || Amount === 0) {
      return i18n.getString(_TL_('No budget selected'));
    }

    const currencyCode = serverContext.CurrentAccount.CurrencyCode;
    const currencySymbol = i18n.getCurrencySymbol(currencyCode);

    const individualBudget = i18n.getString(_TL_('Individual budget'));

    if (Type === BudgetTypes.LifetimeBudgetStandard) {
      return `${individualBudget}: ${currencySymbol}${Amount}/${i18n.getString(_TL_('lifetime'))}`;
    }

    return `${individualBudget}: ${currencySymbol}${Amount}/${i18n.getString(_TL_('day'))}`;
  }, [Amount, Id, Type, i18n, serverContext.CurrentAccount.CurrencyCode]);

  const bidStrategyDetails = useMemo(() =>
    `${i18n.getString(_TL_('Bid strategy'))}: ${getBidTitleDetails(i18n, biddingScheme)}`, [biddingScheme, i18n]);

  return (
    <>
      <div>
        {budgetTitleDetails}
      </div>
      <div>
        {bidStrategyDetails}
      </div>
    </>
  );
};

BudgetBidStrategyDetails.propTypes = {
  budget: PropTypes.shape({
    Amount: PropTypes.number,
    Id: PropTypes.number,
    Type: PropTypes.string,
  }),
  biddingScheme: PropTypes.shape({
    Type: PropTypes.string,
  }),
};

BudgetBidStrategyDetails.defaultProps = {
  budget: {},
  biddingScheme: null,
};
